export default {
  namespaced: true,

  state: {
    layouts: {
      default: {
        CardProductHorizontal: {
          header: {
            type: 'field',
            value: 'sku',
          },
          body: {
            type: 'field',
            value: 'description',
          },
          footerDetails: [
            {
              type: 'field',
              value: 'productSubcategoryName',
            },
            {
              type: 'field',
              value: 'productBrandName',
            },
          ],
        },
        CardProductVertical: {
          header: {
            type: 'field',
            value: 'sku',
          },
          body: {
            type: 'field',
            value: 'description',
          },
          footerDetails: [
            {
              type: 'field',
              value: 'productSubcategoryName',
            },
            {
              type: 'field',
              value: 'productBrandName',
            },
          ],
        },
        CartProduct: {
          header: {
            type: 'field',
            value: 'sku',
          },
          body: {
            type: 'field',
            value: 'description',
          },
          footerDetails: [
            {
              type: 'field',
              value: 'productSubcategoryName',
            },
            {
              type: 'field',
              value: 'productBrandName',
            },
          ],
        },
        ProductInfo: {
          header: {
            type: 'field',
            value: 'sku',
          },
          body: {
            type: 'field',
            value: 'description',
          },
          details: [
            {
              type: 'field',
              value: 'productBrandName',
            },
            {
              type: 'field',
              value: 'productCategoryName',
            },
            {
              type: 'field',
              value: 'productSubcategoryName',
            },
          ],
          tabs: [
            {
              label: 'Descrizione',
              type: 'field',
              component: 'TextCard',
              value: 'extendedDescription',
              iconUrl: '',
            },
          ],
        },
      },
    },
  },

  getters: {
    layouts(state) {
      return state.layouts;
    },
  },
};
